import AutoLoadingButton from "@/components/AutoLoadingButton";
import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import {
    addQuickTimeSelectConfig,
    deleteQuickTimeSelectConfig,
    QuickTimeSelectConfigMode,
} from "@/services/api/companySetting";
import { InputNumber, message, Modal, Radio, Space, Tag } from "antd";
import React, { useEffect, useState } from "react";

interface AddQuickTimeModalProps extends InjectBaseModalProps {}

const tagStyle = {
    margin: 0,
    border: "none",
    backgroundColor: "#f0f2f5",
    padding: "4px 12px",
    color: "#333",
};

const AddQuickTimeModal: React.FC<AddQuickTimeModalProps> = function (props) {
    const { open, onCancel } = props;

    const orderManageStore = useOrderManagementStore();
    const quickTimeSelectConfigs = orderManageStore.storage.quickTimeSelectConfigs;

    const [config, setConfig] = useState({
        selectedMode: QuickTimeSelectConfigMode.HOURS_AGO,
        [QuickTimeSelectConfigMode.HOURS_AGO]: 1,
        [QuickTimeSelectConfigMode.RECENT_HOURS]: 24,
        [QuickTimeSelectConfigMode.RECENT_DAYS]: 7,
    });

    // 通用的值变更处理函数
    const handleValueChange = (key, val) => {
        setConfig((prev) => ({
            ...prev,
            [key]: val,
            selectedMode: key,
        }));
    };

    async function handleAdd() {
        await addQuickTimeSelectConfig(config.selectedMode, config[config.selectedMode]);

        message.success("新增成功");

        onCancel();

        orderManageStore.table.form.setFieldsValue({ quickTimeSelectConfigId: null });

        await orderManageStore.storage.loadQuickTimeSelectConfigs();
    }

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            title="新增快捷选择时间"
            footer={
                <>
                    <AutoLoadingButton onClick={onCancel}>取消</AutoLoadingButton>
                    <AutoLoadingButton type="primary" className="ml10" onClick={handleAdd}>
                        确认新增
                    </AutoLoadingButton>
                </>
            }
        >
            <div style={{ padding: 24, background: "#fff" }}>
                <Radio.Group
                    value={config.selectedMode}
                    onChange={(e) => setConfig({ ...config, selectedMode: e.target.value })}
                >
                    <Space orientation="vertical" size={16}>
                        <Radio value={QuickTimeSelectConfigMode.HOURS_AGO}>
                            <Space>
                                <Tag variant="outlined" style={tagStyle}>新增xxx小时前的搜索</Tag>
                                <InputNumber
                                    value={config[QuickTimeSelectConfigMode.HOURS_AGO]}
                                    onChange={(v) => handleValueChange(QuickTimeSelectConfigMode.HOURS_AGO, v)}
                                    min={1}
                                    precision={0}
                                />
                                <span>小时前</span>
                            </Space>
                        </Radio>

                        <Radio value={QuickTimeSelectConfigMode.RECENT_HOURS}>
                            <Space>
                                <Tag variant="outlined" style={tagStyle}>新增最近xxx小时的搜索</Tag>
                                <span>最近</span>
                                <InputNumber
                                    value={config[QuickTimeSelectConfigMode.RECENT_HOURS]}
                                    onChange={(v) => handleValueChange(QuickTimeSelectConfigMode.RECENT_HOURS, v)}
                                    min={1}
                                    precision={0}
                                />
                                <span>小时内</span>
                            </Space>
                        </Radio>

                        <Radio value={QuickTimeSelectConfigMode.RECENT_DAYS}>
                            <Space>
                                <Tag variant="outlined" style={tagStyle}>新增最近xxx天的搜索</Tag>
                                <span>最近</span>
                                <InputNumber
                                    value={config[QuickTimeSelectConfigMode.RECENT_DAYS]}
                                    onChange={(v) => handleValueChange(QuickTimeSelectConfigMode.RECENT_DAYS, v)}
                                    min={1}
                                    precision={0}
                                />
                                <span>天内</span>
                            </Space>
                        </Radio>
                    </Space>
                </Radio.Group>
            </div>
        </Modal>
    );
};

export default React.memo(AddQuickTimeModal);
